import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import store from './store'
import { injectStore } from './services/api'

import '@coreui/coreui/dist/css/coreui.min.css'
import './scss/style.scss'

// Wire the store into the api module so the response interceptor can dispatch
// tokenRefreshed without creating a circular import (api → store → authSlice → api).
injectStore(store)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
)
